import { combineReducers } from "@reduxjs/toolkit";
import { authSlice } from "./auth";
import { webSlice } from "./dashboard";

export const mainReducer = combineReducers({
  auth: authSlice.reducer,
  web: webSlice.reducer,
});
